<template>
  <div id="MicrophoneIcon" :class="is_on?  'is_on' : null">
      <span v-if="recognition_on">
<svg xmlns="http://www.w3.org/2000/svg"
     :width="parseFloat(size)"
     viewBox="0 0 24 24">
    <path fill="lime" d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"/>
    <path opacity=".3" d="M12 12c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1z"/>
    <path
      d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
    />
</svg>
      </span>
    <span v-else>
<svg xmlns="http://www.w3.org/2000/svg"
     :width="parseFloat(size)"
     viewBox="0 0 24 24">
>
    <path fill="WhiteSmoke" d="M0 0h24v24H0V0z"/>
    <path
      opacity=".3" d="M12 3.7c-.66 0-1.2.54-1.2 1.2v1.51l2.39 2.39.01-3.9c0-.66-.54-1.2-1.2-1.2z"/>
    <path
      d="M19 11h-1.7c0 .58-.1 1.13-.27 1.64l1.27 1.27c.44-.88.7-1.87.7-2.91zM4.41 2.86L3 4.27l6 6V11c0 1.66 1.34 3 3 3 .23 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.55-.9l4.2 4.2 1.41-1.41L4.41 2.86zM10.8 4.9c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2l-.01 3.91L15 10.6V5c0-1.66-1.34-3-3-3-1.54 0-2.79 1.16-2.96 2.65l1.76 1.76V4.9z"
    />
</svg>
        </span>
   <br/>
    <span id="icon_label">
      {{recognition_on ? "on" : "off"}}
    </span>
  </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "MicrophoneIcon",
        props: {
            is_on: Boolean,
            size: {default: 24}
        },
        computed: mapState(['recognition_on']),
    }
</script>

<style scoped>
  @keyframes shadow-pulse
  {
    0% {
      box-shadow: 0 0 0 -10px rgba(0, 0, 0, 0.3);
    }
    100% {
      box-shadow: 0 0 0 25px rgba(0, 0, 0, 0);
    }
  }
  #MicrophoneIcon.is_on{
    animation: shadow-pulse 1s infinite;
  }
  #icon_label {
    font-size: 0.5rem;
  }
  #MicrophoneIcon {
    position: relative;
    border-radius: 50%;
  }
  svg {
    text-align: center;
    position: absolute;
    left: 50%;
    display: inline-block;
    transform: translateX(-50%);
  }
</style>
